/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
// MUI
import { TextField, FormControlLabel, Checkbox, Autocomplete, Box } from '@mui/material';
// Picker
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ptLocale from 'date-fns/locale/pt';

// Components
import HorasButtons from './HorasButtons';

function RegistoPeriodo({
  novoRegisto,
  setNovoRegisto,
  classes,
  setHoras,
  validateOnChange = true,
  valueTipoAtrasoAutoComplete,
  setValueTipoAtrasoAutoComplete,
  valueTipoPeriodoAutoComplete,
  setValueTipoPeriodoAutoComplete,
  tiposperiodos,
  tiposatrasos,
  validationNovoRegistoDiario,
  errorsNovoRegistoDiario,
  horas,
}) {
  const handleDataInicioChange = (date) => {
    setNovoRegisto({
      ...novoRegisto,
      dataInicioDiario: date,
    });
    if (validateOnChange) validationNovoRegistoDiario({ dataInicioDiario: date });
  };

  const handleData = (currentHoras) => {
    // eslint-disable-next-line no-param-reassign
    // novoRegisto.qtd = currentHoras;
    setHoras(currentHoras);
    if (novoRegisto.tipo === 1) {
      setNovoRegisto({
        ...novoRegisto,
        qtdDiario: currentHoras,
      });
    }
    if (novoRegisto.tipo === 2) {
      setNovoRegisto({
        ...novoRegisto,
        qtdPeriodo: currentHoras,
      });
    }
  };

  useEffect(() => {
    if (horas > 24) {
      setHoras(8);
      setNovoRegisto({
        ...novoRegisto,
        horas: 8,
        qtd: 8,
      });
    }
  }, [horas]);

  // ------------------------------ Handle Falta--------------------------//

  const handleFaltas = (falta) => {
    setNovoRegisto({ ...novoRegisto, faltou: falta });
  };

  // --------------------------------------------------------------------//

  // ------------------------ Handle Autocompletes----------------------//
  const handleChangeAtrasos = (value) => {
    setValueTipoAtrasoAutoComplete(value);
    setNovoRegisto({
      ...novoRegisto,
      tipoAtrasoId: value,
    });
  };

  const handleChangePeriodo = (value) => {
    setValueTipoPeriodoAutoComplete(value);
    setNovoRegisto({
      ...novoRegisto,
      tipoPeriodoId: value,
    });
  };
  // --------------------------------------------------------------------//

  const handleChangeObservacoes = (e) => {
    setNovoRegisto({
      ...novoRegisto,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <Box sx={{ width: '100%', mb: 2, display: 'flex', flexDirection: 'column' }}>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptLocale}>
          <b>Data Inicio</b>
          <DatePicker
            sx={{ width: '45%' }}
            margin="normal"
            id="date-picker-dialog"
            format="dd/MM/yyyy"
            okLabel="ok"
            cancelLabel="cancelar"
            value={novoRegisto && novoRegisto.dataInicioDiario}
            onChange={handleDataInicioChange}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: 'dd/mm/aaaa',
                }}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
                variant="outlined"
                size="small"
              />
            )}
            // helperText="Data inválida"
            {...(errorsNovoRegistoDiario.dataInicioDiario && {
              error: true,
              helperText: errorsNovoRegistoDiario.dataInicioDiario,
            })}
          />
        </LocalizationProvider>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ width: '30%' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={novoRegisto.faltou}
                onChange={() => {
                  handleFaltas(!novoRegisto.faltou);
                }}
                name="falta"
                disabled={
                  !(
                    (novoRegisto && Object.keys(novoRegisto.funcionarioId).length > 0) ||
                    novoRegisto.funcionarioId != 0
                  )
                }
              />
            }
            label="Falta"
            // style={{ width: '20%' }}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '70%' }}>
          <Box className={classes.horasBorderPeriodoTextfield}>
            <h4>{novoRegisto.qtdDiario}h</h4>
          </Box>
          <HorasButtons recurso={novoRegisto} classes={classes} handleData={handleData} />
        </Box>
      </Box>
      <div>
        <div className="autocompletes">
          {novoRegisto && novoRegisto.faltou == true ? (
            <div className="tipoPeriodo">
              <b>Tipo de Periodo</b>
              <Autocomplete
                id="tipoPeriodoId"
                name="tipoPeriodoId"
                noOptionsText="Sem dados"
                onChange={(e, value) => handleChangePeriodo(value)}
                clearText="Limpar"
                openText="Abrir"
                closeText="Fechar"
                value={valueTipoPeriodoAutoComplete}
                options={tiposperiodos || [{ id: 0, descricao: '' }]}
                getOptionLabel={(option) => (option.descricao ? `${option.descricao} ` : '')}
                filterOptions={(options, state) => {
                  return options.filter(
                    (option) =>
                      option.id > 0 &&
                      `${option.descricao}`.toLowerCase().includes(state.inputValue.toLowerCase()),
                  );
                }}
                getOptionSelected={(option, value) => {
                  // if (!value.id) return true;

                  return value.id === option.id;
                }}
                autoComplete
                includeInputInList
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    placeholder="Tipo de Periodo"
                    // required
                    // {...(errors.recursosId && { error: true, helperText: errors.recursosId })}
                  />
                )}
              />
            </div>
          ) : null}

          <div
            className={
              novoRegisto.faltou == true ? 'periodo-atrasos-true' : 'periodo-atrasos-false'
            }
            //  style={novoRegisto.faltou == true ? { width: '48%' } : { width: '100%' }}
          >
            <b>Tipo de Atraso</b>
            <Autocomplete
              id="tipoAtrasoId"
              name="tipoAtrasoId"
              noOptionsText="Sem dados"
              onChange={(e, value) => handleChangeAtrasos(value)}
              clearText="Limpar"
              openText="Abrir"
              closeText="Fechar"
              value={valueTipoAtrasoAutoComplete}
              options={tiposatrasos || [{ id: 0, descricao: '' }]}
              getOptionLabel={(option) => (option.descricao ? `${option.descricao} ` : '')}
              filterOptions={(options, state) => {
                return options.filter(
                  (option) =>
                    option.id > 0 &&
                    `${option.descricao}`.toLowerCase().includes(state.inputValue.toLowerCase()),
                );
              }}
              getOptionSelected={(option, value) => {
                // if (!value.id) return true;

                return value.id === option.id;
              }}
              autoComplete
              includeInputInList
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  placeholder="Tipo de Atraso"
                  // required
                  // {...(errors.recursosId && { error: true, helperText: errors.recursosId })}
                />
              )}
            />
          </div>
        </div>
      </div>
      <Box style={{ marginTop: '10px' }}>
        <Box>
          <b>Observações</b>
          <TextField
            name="observacoes"
            variant="outlined"
            style={{ width: '100%' }}
            size="small"
            // disabled={
            //   recurso && (recurso.validadoAD || recurso.validadoRH || recurso.validadoCD)
            // }
            multiline
            value={novoRegisto.observacoes || ''}
            onChange={handleChangeObservacoes}
            placeholder="Observações"
          />
        </Box>
      </Box>
    </>
  );
}

export default RegistoPeriodo;
